import { MarkDown, InfoTooltip, Flex } from "@wayflyer/flyui";
import { styled } from "styled-components";

const StyledPopupMarkDown = styled(MarkDown)<{ padding?: string }>`
  /* Fill the tooltip up to its max-width (flyui caps ReactNode content at ~450px)
     and wrap, rather than forcing a fixed width that overflows and crops. */
  max-width: 100%;
  padding: ${({ padding }) => {
    return padding ?? "1.5em";
  }};
  h1:not(:first-of-type),
  h2:not(:first-of-type),
  h4:not(:first-of-type),
  h5:not(:first-of-type) {
    margin-block-start: 1.5em;
    margin-block-end: 0;
  }

  p {
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
  }
`;

export interface TabTitleProps {
  title: string;
  tooltip?: string;
}

const H3 = styled.h3`
  display: inline-flex;
  align-items: center;
  gap: var(--sizes-spacing-1);
`;

export const TabTitle = ({ title, tooltip }: TabTitleProps) => {
  return (
    <Flex align="center" gap="1">
      <H3>{title}</H3>
      {tooltip ? <InfoTooltip content={<StyledPopupMarkDown markdown={tooltip} />} /> : null}
    </Flex>
  );
};
